module.exports = __webpack_public_path__ + "be36647a6a01b259801fb04806496e2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/blue.svg
// module id = 1095
// module chunks = 0